import {
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { Observable, of } from "rxjs";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { TypeaheadService } from "~app/common/services/typeahead/typeahead.service";
import { TypeAhead } from "~app/common/services/typeahead/typeahead.types";
import { IHandelssortimentTypeAhead } from "~app/features/forsaljning/handelssortiment/handelssortiment.models";
import { OrderService } from "~app/features/forsaljning/order/order.service";
import { DisabledControlDirective } from "../../../../../../common/directives/disabled-control/disabled-control.directive";
import { IHandelssortiment } from "../../../models/kundorder-detail-model";

@Component({
    selector: "rask-kundorderrad-inmatningshandelssortiment",
    templateUrl: "./kundorderrad-inmatningshandelssortiment.component.html",
    styleUrls: ["./kundorderrad-inmatningshandelssortiment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonComponent,
        SelectorComponent,
        FormsModule,
        DisabledControlDirective
    ]
})
export class KundorderradInmatningshandelssortimentComponent {
    @Input() beraknatInmatningshandelssortiment: IHandelssortiment;
    hasInitialized = false;
    @Input() inmatningshandelssortiment: IHandelssortiment;
    @Input() kundorderradId: number;
    @Input() matchesViol3Regelverk: boolean;
    @Input() mottagningsplatsnummer: string;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onChange = new EventEmitter();
    @Input() readonly = false;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly orderService = inject(OrderService);
    private readonly router = inject(Router);
    private readonly typeaheadService = inject(TypeaheadService);

    canEdit = () => this.authenticationService.canEdit() && !this.readonly;

    handelssortimentFormatter = (item: IHandelssortimentTypeAhead) => item ? item.id : null;

    handelssortimentViewFormatter = (item: IHandelssortimentTypeAhead) => item ? `${item.violId || ""} ${item.namn}` : null;

    onSelectChange(handelssortiment: IHandelssortiment) {
        this.inmatningshandelssortiment = handelssortiment;
        this.onChange.emit(this.inmatningshandelssortiment);
    }

    openRegelverk() {
        const violId = this.inmatningshandelssortiment?.violId || this.beraknatInmatningshandelssortiment.violId;
        const url = this.router.serializeUrl(this.router.createUrlTree(["core/regelverkviol3"],
            {
                queryParams:
                {
                    violId: violId,
                    mottagningsplatsnummer: this.mottagningsplatsnummer
                }
            }));
        window.open(url, "_blank");
    }

    searchForHandelssortiment = (input: string): Observable<IHandelssortimentTypeAhead[]> => input.length < 3
        ? this.getPreload(TypeAhead.Handelssortiment)
        : this.orderService.searchForHandelssortimentTypeAhead(input, null, true);

    private getPreload<T>(type: string): Observable<T[]> {
        return of(this.typeaheadService.getPreload<T>(type, "Ange minst 3 tecken"));
    }
}
